class MobileMenu {
	constructor(el) {
		this.el = el;
		this.headerHeight = 0;

		this.setupEventHandlers();
		
	}

	setupEventHandlers() {

		const menuItemHasChildren = this.el.querySelectorAll('.menu-item-has-mega');
		
		menuItemHasChildren.forEach(m => {
			const downArrowEl = document.createElement('span');
			downArrowEl.classList.add('mobile-down-arrow');
			const link = m.querySelector('a');
			
			link.after(downArrowEl);
			downArrowEl.addEventListener('click', () => {
				const subMenu = m.querySelector('.mega-menu__section');
				subMenu.classList.toggle('active');
				m.classList.toggle('active');
				
			})
		})

	}

}

export default MobileMenu;